module.exports = __webpack_public_path__ + "static/media/better-business-bureau.894e8013.png";